module.exports = __webpack_public_path__ + "img/ET.c1bfb1e8.svg";